import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) { }
  init() {
    const src = '../../../assets/icons-uikits/';
    const srcIcon = '../../../assets/icon/';

    this.matIconRegistry.addSvgIcon(
      'printer',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/printer.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'retirement',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/deliver.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'returned',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/order_return.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'returned_seller',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/order_return_seller.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'returned_origin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/order_return_seller.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'locate-dispatches',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/locate.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'locate',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/locate.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'edit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/edit.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'trash',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/trash.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'cancel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/ico_cancel_barra.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'image_search',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/image_search.svg`)
    ); */
    /* this.matIconRegistry.addSvgIcon(
      'business_center',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/business_center.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'cancel_sale_note_items',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/ico_cancel_sale_note_items.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'check-circle-regular',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/check-circle-regular.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'picker',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/picker.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'block_user',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/block_user.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'picking_blue',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/picking_blue.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'picking',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/picking.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'consolidado',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/consolidado.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'eraser',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/eraser.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'dispatchToCustomer',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/operations.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'move',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/move.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'map',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/map.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'delivery',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/car.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'resend',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/resend.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'down',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/drop/down.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'deliver',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/deliver.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'warning',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/warning.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'sale',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/sale.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'configuration',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/configuration.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'operations',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/operations.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'report',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/reporte.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'approved',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/approved.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'user',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/user.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'copy',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/copy.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'flag',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/flag.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'pdf',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/pdf.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'cross',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/cancelar.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'search-list',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/searchlist.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'excel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/excel.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'excel_black',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/excel-black.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'done',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/done.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'printer_thermal',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/thermal.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'report_picking',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/report_picking.svg`)
    ); */
    /* this.matIconRegistry.addSvgIcon(
      'searchNote',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/searchNote.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'dispatchesCanceled',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/despatchcancel.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'notification',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/notification.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'save',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/save.svg`)
    );
    /* this.matIconRegistry.addSvgIcon(
      'icoTable',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/ico-table.svg`)
    ); */
    this.matIconRegistry.addSvgIcon(
      'download-template',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/download.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'upload-excel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/upload.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'load',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/load.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'pocket',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/pocket.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'question',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/question.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'discount',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/discount.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'information',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/information.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'user-setting',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/user-settings.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'external-report',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/external-report.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'product',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/product.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'car',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/car.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'settings',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/settings.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'photo',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/photo-gallery.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'service-assembly',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/service-assembly.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'dashboard',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}dashboard/dashboard.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'load-trip',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/inventory.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'load-percentage',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/free-delivery.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'add-jaba',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}pick/audit/add-to-cart.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'pre-cancel',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}pick/audit/cancel.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'confirm-audit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}pick/audit/confirm-audit.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'confirm-multiple-audit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}pick/audit/confirm-audit.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'check-audit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/checking.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'new-lot',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}pick/lots-management/new-lot.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'settlementReport',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}report/settlementReport.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'ajust-inventory',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/ajust_inventory.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'capacityReport',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}report/capacityReport.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'info',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}shared/info.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'calendar',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/calendar.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      'exception-days',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/exception-days.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'new-info',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/info.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'exchange',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/order_return.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'return',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/deliver.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'add-dispatch',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/add_basket.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'user-external',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}report/analytics_menu.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'logout',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/logout.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'deactivate-user',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${src}ico/person_remove.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'time-settings',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}configuration/time-settings.svg`)
    );
    this.matIconRegistry.addSvgIcon(
      'support-module',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`${srcIcon}support/support.svg`),
    );
  }
}
